<template>
    <div id="sidebar">
        <v-navigation-drawer v-model="sidebarStatus" app>
            <v-row>
                <v-col cols="10">
                    <v-img src="/img/Heliocity_logo_web_couleur-1.png" style="margin: 8px 10px -6px;"/>
                </v-col>
            </v-row>
            <SidebarMenu/>
        </v-navigation-drawer>
    </div>
</template>

<script>
    import SidebarMenu from "./SidebarMenu.vue";

    export default {
        name: "Sidebar",
        components: {SidebarMenu},
        computed: {
            sidebarStatus: {
                get() {
                    return this.$store.getters.sidebarStatus;
                },
                set(val) {
                    this.$store.commit("SET_SIDEBAR_STATUS", val);
                }
            }
        },
    };
</script>

<style lang="scss">
    .v-navigation-drawer__border {
        display: none;
    }
</style>
